module.exports = __webpack_public_path__ + "static/media/21-8.225ad6a8.mp3";